import Cookies from 'js-cookie'

const user = {
    state: {
        token: null,
        tokenExpire: null,
        tagsStoreList: [],
        language: Cookies.get('language') || 'en',
        phoneType: '',
    },
    getters:{
        getTokenExpire(state){
            return state.tokenExpire
        },
        getLanguage(state){
            return state.language
        },
        getPhoneType: state => state.phoneType,
    },
    mutations: {
        saveToken(state, data) {
            state.token = data;
            window.localStorage.setItem("Token", data);
        },
        saveTokenExpire(state, data) {
            state.tokenExpire = data;
            window.localStorage.setItem("TokenExpire", data);
        },
        saveTagsData(state, data) {
            state.tagsStoreList = data;
            sessionStorage.setItem("Tags", data)
        },
        SET_LANGUAGE: (state, language) => {
            state.language = language
            Cookies.set('language', language)
        },
        changePhoneType: (state, text) => { state.phoneType = text },
    },
    actions: {
        setLanguage({ commit }, language) {
            commit('SET_LANGUAGE', language)
        },
        setPhoneType: (context, text) => { context.commit('changePhoneType', text) },
    }
}

export default user